import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './app'; // Changed from './App' to './app'

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);